var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
import React, { useState, useEffect, useMemo, useCallback, useRef, } from 'react';
import { services } from '../../../shared';
import { PageHeading, Row } from '../../shared';
import { ClientDashboard } from '../../sections';
import { Container, Column, Button, Dialog } from '../../shared';
import { BackButton } from './BackButton';
import { CardClientDetails } from '../../sections/card-client-details';
import { CardClientDownloads } from '../../sections/card-client-downloads';
import { defaultErrorResponse, hasError } from '../../../shared/types/service-handling';
export var clientInitialState = {
    data: [],
    loading: false,
    error: false,
};
export var ClientsPage = function () {
    var _a = useState([]), formTitles = _a[0], setAddClientTitles = _a[1];
    var _b = useState([]), clientList = _b[0], setClientList = _b[1];
    var _c = useState(' '), searchTerm = _c[0], setSearchTerm = _c[1];
    var _d = useState('Id'), sortColumn = _d[0], setSortColumn = _d[1];
    var _e = useState('Desc'), sortOrder = _e[0], setSortOrder = _e[1];
    var _f = useState(' '), keyPressed = _f[0], setKeyPressed = _f[1];
    var _g = useState([]), clientCases = _g[0], setClientCases = _g[1];
    var _h = useState(null), activeClient = _h[0], setActiveClient = _h[1];
    var _j = useState(false), activeSelectClient = _j[0], setActiveSelectClient = _j[1];
    var _k = useState([]), activeClientDocuments = _k[0], setActiveClientDocuments = _k[1];
    var _l = useState(clientInitialState), testClientData = _l[0], setClientData = _l[1];
    var _m = useState(), modalVisible = _m[0], setModalVisible = _m[1];
    var _o = useState(0), noOfExistingClients = _o[0], setNoOfExistingClients = _o[1];
    var isEditSelected = useRef(false);
    var pageSize = 10;
    var fetchTitlesData = function () { return __awaiter(void 0, void 0, void 0, function () {
        var res;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0: return [4 /*yield*/, services.getTitles()];
                case 1:
                    res = _a.sent();
                    setAddClientTitles(res.data);
                    return [2 /*return*/];
            }
        });
    }); };
    var getActiveClientByList = function (clients, position) { return __awaiter(void 0, void 0, void 0, function () {
        var firstId, index, clientId;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    if (!((clients === null || clients === void 0 ? void 0 : clients.length) && position === undefined)) return [3 /*break*/, 2];
                    firstId = clients[0].id;
                    return [4 /*yield*/, services.getCustomer(Number(firstId))];
                case 1: return [2 /*return*/, _a.sent()];
                case 2:
                    index = 0;
                    _a.label = 3;
                case 3:
                    if (!(index < clients.length)) return [3 /*break*/, 6];
                    if (!(position === index)) return [3 /*break*/, 5];
                    clientId = clients[index].id;
                    return [4 /*yield*/, services.getCustomer(Number(clientId))];
                case 4: return [2 /*return*/, _a.sent()];
                case 5:
                    index++;
                    return [3 /*break*/, 3];
                case 6: return [2 /*return*/, null];
            }
        });
    }); };
    var fetchClients = function (searchTerm) { return __awaiter(void 0, void 0, void 0, function () {
        var clients, firstClient, customerId, cases, clientDocuments;
        var _a, _b;
        return __generator(this, function (_c) {
            switch (_c.label) {
                case 0:
                    setClientData(__assign(__assign({}, testClientData), { loading: true }));
                    setSearchTerm(searchTerm);
                    return [4 /*yield*/, services.search(searchTerm !== null && searchTerm !== void 0 ? searchTerm : ' ', 1, pageSize)];
                case 1:
                    clients = _c.sent();
                    setClientData(clients);
                    if (!clients.data) return [3 /*break*/, 5];
                    setClientList(clients.data);
                    return [4 /*yield*/, getActiveClientByList(clients.data)];
                case 2:
                    firstClient = _c.sent();
                    setActiveClient(firstClient === null || firstClient === void 0 ? void 0 : firstClient.data);
                    customerId = (_b = (_a = firstClient === null || firstClient === void 0 ? void 0 : firstClient.data) === null || _a === void 0 ? void 0 : _a.id) !== null && _b !== void 0 ? _b : 0;
                    return [4 /*yield*/, services.getCaseSummary('', 1, 10, 'ApplicationId', 'Desc', customerId)];
                case 3:
                    cases = (_c.sent()).data;
                    setClientCases(cases);
                    return [4 /*yield*/, services.getCustomerDocuments(customerId)];
                case 4:
                    clientDocuments = (_c.sent()).data;
                    setActiveClientDocuments(clientDocuments);
                    setClientValues(customerId);
                    _c.label = 5;
                case 5: return [2 /*return*/, clients.data];
            }
        });
    }); };
    var fetchPageData = function (pageNumber, pageSize) { return __awaiter(void 0, void 0, void 0, function () {
        var clients, activeClient;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0: return [4 /*yield*/, services.search(searchTerm !== null && searchTerm !== void 0 ? searchTerm : ' ', pageNumber, pageSize, sortColumn, sortOrder)];
                case 1:
                    clients = _a.sent();
                    setClientList(clients.data);
                    return [4 /*yield*/, getActiveClientByList(clients.data, 0)];
                case 2:
                    activeClient = _a.sent();
                    getRowId(activeClient === null || activeClient === void 0 ? void 0 : activeClient.data.id);
                    return [2 /*return*/, clients.data];
            }
        });
    }); };
    var fetchSortedData = function (column, order) { return __awaiter(void 0, void 0, void 0, function () {
        var clients;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    setSortOrder(order);
                    setSortColumn(column.id);
                    return [4 /*yield*/, services.search(searchTerm !== null && searchTerm !== void 0 ? searchTerm : ' ', 1, pageSize, column.id, order)];
                case 1:
                    clients = _a.sent();
                    setClientList(clients.data);
                    return [2 /*return*/, clients.data];
            }
        });
    }); };
    var handleKey = function (e) {
        setKeyPressed(e.currentTarget.value);
    };
    var handleBack = function () { return __awaiter(void 0, void 0, void 0, function () {
        return __generator(this, function (_a) {
            setActiveSelectClient(false);
            return [2 /*return*/];
        });
    }); };
    var setClientValues = function (customerId) { return __awaiter(void 0, void 0, void 0, function () {
        var cases, clientDocuments;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    if (!customerId) return [3 /*break*/, 3];
                    return [4 /*yield*/, services.getCaseSummary('', 1, 10, 'LastUpdatedDate', 'Desc', customerId)];
                case 1:
                    cases = _a.sent();
                    setClientCases(cases.data);
                    return [4 /*yield*/, services.getCustomerDocuments(Number(customerId))];
                case 2:
                    clientDocuments = _a.sent();
                    setActiveClientDocuments(clientDocuments.data);
                    _a.label = 3;
                case 3: return [2 /*return*/];
            }
        });
    }); };
    var documentGridRefresh = function () { return __awaiter(void 0, void 0, void 0, function () {
        return __generator(this, function (_a) {
            setClientValues(activeClient === null || activeClient === void 0 ? void 0 : activeClient.id);
            return [2 /*return*/];
        });
    }); };
    var getRowId = function (customerId) { return __awaiter(void 0, void 0, void 0, function () {
        var client, cases, clientDocuments;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0: return [4 /*yield*/, services.getCustomer(customerId)];
                case 1:
                    client = _a.sent();
                    setActiveClient(client.data);
                    setActiveSelectClient(!isEditSelected.current);
                    return [4 /*yield*/, services.getCaseSummary('', 1, 10, 'ApplicationId', 'Desc', customerId)];
                case 2:
                    cases = (_a.sent()).data;
                    setClientCases(cases);
                    return [4 /*yield*/, services.getCustomerDocuments(customerId)];
                case 3:
                    clientDocuments = (_a.sent()).data;
                    setActiveClientDocuments(clientDocuments);
                    setClientValues(customerId);
                    return [2 /*return*/];
            }
        });
    }); };
    var hideModal = function () {
        setModalVisible(false);
    };
    var getNoOfClients = function () { return __awaiter(void 0, void 0, void 0, function () {
        var clients;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0: return [4 /*yield*/, services.search(searchTerm !== null && searchTerm !== void 0 ? searchTerm : ' ', 1, pageSize)];
                case 1:
                    clients = _a.sent();
                    setNoOfExistingClients(clients === null || clients === void 0 ? void 0 : clients.data.length);
                    return [2 /*return*/];
            }
        });
    }); };
    useEffect(function () {
        fetchTitlesData();
        getNoOfClients();
    }, []);
    useEffect(function () {
        fetchClients(keyPressed);
    }, [keyPressed]);
    var handleRemoveClient = function () { return __awaiter(void 0, void 0, void 0, function () {
        var clientId, currentPosition, clients, restOfClients;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    clientId = Number(activeClient.id);
                    currentPosition = clientList === null || clientList === void 0 ? void 0 : clientList.findIndex(function (client) { var _a; return ((_a = client === null || client === void 0 ? void 0 : client.id) === null || _a === void 0 ? void 0 : _a.toString()) === clientId.toString(); });
                    return [4 /*yield*/, services.removeClient(clientId)];
                case 1:
                    _a.sent();
                    return [4 /*yield*/, services.search(searchTerm !== null && searchTerm !== void 0 ? searchTerm : ' ', 1, pageSize)];
                case 2:
                    clients = _a.sent();
                    restOfClients = (clientList !== null && clientList !== void 0 ? clientList : []).filter(function (client) { return client.id.toString() !== clientId.toString(); });
                    if (!((restOfClients === null || restOfClients === void 0 ? void 0 : restOfClients.length) == 0 && searchTerm == '' && (clients === null || clients === void 0 ? void 0 : clients.data[0].pageCount) > 0)) return [3 /*break*/, 4];
                    return [4 /*yield*/, services.search(searchTerm !== null && searchTerm !== void 0 ? searchTerm : ' ', clients.data[0].pageCount, pageSize)];
                case 3:
                    clients = _a.sent();
                    setClientList(clients.data);
                    setActiveClientAfterRemoval(clients.data, currentPosition);
                    return [3 /*break*/, 5];
                case 4:
                    setClientList(restOfClients);
                    setActiveClientAfterRemoval(restOfClients, currentPosition);
                    _a.label = 5;
                case 5:
                    setModalVisible(false);
                    return [2 /*return*/];
            }
        });
    }); };
    var RefreshClientDetails = function (id) { return __awaiter(void 0, void 0, void 0, function () {
        var clients;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0: return [4 /*yield*/, services.search(' ', 1, pageSize)];
                case 1:
                    clients = _a.sent();
                    setClientList(clients.data);
                    if (id == 0 && clients.data.length > 0) {
                        getRowId(parseInt(clients.data[0].id));
                    }
                    else {
                        getRowId(id);
                    }
                    return [2 /*return*/];
            }
        });
    }); };
    var setActiveClientAfterRemoval = function (clients, currentPosition) { return __awaiter(void 0, void 0, void 0, function () {
        var nextClient;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    if ((clients === null || clients === void 0 ? void 0 : clients.length) === currentPosition) {
                        currentPosition--;
                    }
                    return [4 /*yield*/, getActiveClientByList(clients, currentPosition)];
                case 1:
                    nextClient = _a.sent();
                    if (nextClient !== null) {
                        getRowId(nextClient === null || nextClient === void 0 ? void 0 : nextClient.data.id);
                    }
                    return [2 /*return*/];
            }
        });
    }); };
    var renderClientDocuments = useCallback(function () {
        return (React.createElement(CardClientDownloads, { documents: activeClientDocuments, clientId: activeClient.id, documentGridRefresh: documentGridRefresh }));
    }, [activeClient, activeClientDocuments, documentGridRefresh]);
    var renderClientCard = useMemo(function () {
        if (!activeClient) {
            return null;
        }
        return (React.createElement(React.Fragment, null,
            React.createElement(CardClientDetails, { client: activeClient, cases: clientCases }),
            renderClientDocuments(),
            React.createElement("div", { className: "u-flex u-mt-2 u-width-100 u-background-white" },
                React.createElement(Button, { type: "button", variant: "outline", dataValue: activeClient.id, onClick: function () { return setModalVisible(!modalVisible); }, width: "full" }, "Remove client"))));
    }, [activeClient, activeClientDocuments, clientCases]);
    if (hasError([testClientData])) {
        return defaultErrorResponse();
    }
    var handleClickEdit = function (e) {
        if (e.nativeEvent.type === 'click') {
            isEditSelected.current = true;
        }
    };
    var handleCloseEdit = function () {
        isEditSelected.current = false;
    };
    return (React.createElement("section", null,
        React.createElement(Dialog, { message: "Are you sure you want to remove this client?", show: modalVisible, handleClose: hideModal, submit: handleRemoveClient, showYesButton: true }),
        React.createElement(PageHeading, { headingLevel: 2, title: "Clients", icon: "clients", mb: 6 }),
        React.createElement(BackButton, { type: "button", variant: "outline", onClick: handleBack, width: "full", hiddenInLargerScreens: true, visibility: activeSelectClient }, "back"),
        React.createElement(Container, { fullWidth: true },
            React.createElement(Row, null,
                React.createElement(Column, { hiddenInSmallerScreens: !!activeSelectClient },
                    React.createElement(ClientDashboard, { clientList: clientList, pageSize: pageSize, formTitles: formTitles, sortFunction: fetchSortedData, pageFunction: fetchPageData, handleKey: handleKey, getRowId: getRowId, fetchClients: fetchClients, noOfExistingClients: noOfExistingClients, refreshClientDetails: RefreshClientDetails, handleClickEdit: handleClickEdit, handleCloseEdit: handleCloseEdit })),
                React.createElement(Column, { spaced: true, hiddenInSmallerScreens: !activeSelectClient, extendClass: "c-client-col" }, clientList.length > 0 && renderClientCard)))));
};
